<template>
    <div class="container-fluid">
        <div class="loading-state" v-if="loading">
            <ProgressSpinner fill="transparent" aria-label="Loading" />
        </div>
        <div class="row mb-5">
            <div class="col-12">
                <div class="card h-100 mt-3">
                    <div class="card-header mb-0">
                        <h5>{{ $t("content.gprinttk") }}</h5>
                    </div>
                    <div class="card-body pt-0">
                        <div class="row">
                            <div class="col-lg-3">
                                <label class="form-label ms-0">{{ $t("content.sdate") }}</label>
                                <VueDatePicker v-model="start_date" :format="format" auto-apply :teleport="true"
                                    :max-date="new Date()" :enable-time-picker="false" month-name-format="long"
                                    :clearable="false" :text-input="textInputOptions" fluid />
                            </div>

                            <div class="col-lg-3">
                                <label class="form-label ms-0">{{ $t("content.edate") }}</label>
                                <VueDatePicker v-model="end_date" :format="format" auto-apply :teleport="true"
                                    :max-date="new Date()" :enable-time-picker="false" month-name-format="long"
                                    :clearable="false" :text-input="textInputOptions" fluid />
                            </div>

                            <div class="col-lg-1">
                                <label class="form-label ms-0 png"></label>
                                <material-button id="searchBtn" color="primary" class="float-lg-start float-sm-end mb-3"
                                    :disabled="start_date > end_date" @click="getOnlineList">
                                    <i class="material-icons material-symbols-outlined">search</i>
                                    {{ $t("buttons.sear") }}
                                </material-button>
                            </div>
                            <div class="col-lg-1">
                                <label class="form-label ms-0 png"></label>
                                <material-button id="cancelBtn" color="danger" class="float-lg-start float-sm-end mb-3"
                                    @click="cancelBtn">
                                    <i class="material-icons material-symbols-outlined">close</i>
                                    {{ $t("buttons.canc") }}
                                </material-button>
                            </div>

                        </div>

                        <hr />

                        <div class="row no-gutters">
                            <div class="col-12 d-flex justify-content-end align-items-center">
                                 <div class="me-3">
                                    <material-button id="pdfBtn" color="dark" variant="outline"
                                        class="float-lg-start float-sm-end mb-0 me-2" :title="t('buttons.printp')"
                                        @click="ticketListGen()" :disabled="listdata.length === 0">
                                        <i class="material-icons material-symbols-outlined">print</i>
                                    </material-button>
                                 </div>
                                 <div class="me-3">
                                    <material-button id="excelBtn" color="secondary" variant="outline"
                                        cclass="float-lg-start float-sm-end mb-0 me-2" :title="t('buttons.printpb')"
                                        @click="backCoverListGen()" :disabled="listdata.length === 0">
                                        <i class="material-icons material-symbols-outlined">description</i>
                                    </material-button>
                                 </div>
                                 <div class="me-3">
                                    <material-button id="excelBtn" color="danger" variant="outline"
                                        cclass="float-lg-start float-sm-end mb-0 me-2" :title="t('content.printrepltk')"
                                        @click="replaceTicketListGen()" :disabled="listdata.length === 0">
                                        <i class="material-icons material-symbols-outlined">receipt</i>
                                    </material-button>
                                 </div>
                            </div>
                        </div>
                        <pre></pre>
                        <div class="row mt-3">
                            <div class="table-responsive">
                                <table class="table table-flush">
                                    <thead class="thead-light">
                                        <tr>
                                            <th class="text-sm font-weight-normal text-center">
                                                <material-checkbox v-model="allTk" :checked="allTk" @change="setAllTk()"
                                                    :disabled="listdata.length === 0">
                                                </material-checkbox>
                                            </th>
                                            <th>#</th>
                                            <th>{{ $t("content.amndatetime") }}</th>
                                            <th>{{ $t("content.tkOwner") }}</th>
                                            <th>{{ $t("content.amnticketold") }}</th>
                                            <th>{{ $t("content.ticketno") }}</th>
                                            <th>{{ $t("content.payside") }}</th>
                                            <th>{{ $t("content.amnbiz") }}</th>
                                            <th>{{ $t("content.amnweightvalall") }}</th>
                                            <th>{{ $t("content.amnqtyunitall") }}</th>
                                            <th>{{ $t("content.amnpawnvalall") }}</th>
                                            <th>{{ $t("content.amnreceiveprofit") }}</th>
                                            <th>
                                                {{ $t("content.actpawn3") }} /
                                                {{ $t("content.actpawn4") }}
                                            </th>
                                            <th>{{ $t("content.gpay") }}</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in listdata" :key="index"
                                            :class="row.paySide == 'PAY' && row.migration ? 'bg-redeem'
                                                : row.paySide == 'PAY' && !row.migration ? 'bg-payment'
                                                    : row.paySide === 'RECEIVE' && row.migration ? 'bg-reduce-cap'
                                                        : row.paySide === 'RECEIVE' && !row.migration ? 'bg-receive'
                                                            : row.paySide === 'NONE' && row.migration ? 'bg-nonemi' : 'bg-none'">
                                            <td class="text-sm font-weight-normal text-center">
                                                <material-checkbox v-model="row.chk" :checked="row.chk"
                                                    @change="setTk(row)">
                                                </material-checkbox>
                                            </td>
                                            <td class="text-sm font-weight-normal">
                                                {{ formatNumberString((currentPage - 1) * perPage + index + 1) }}
                                            </td>
                                            <td class="text-sm font-weight-normal">
                                                {{ format_datetime(row.createDate) }}
                                            </td>
                                            <td class="text-sm font-weight-normal">
                                                {{ row.tkCusName }}
                                            </td>
                                            <td class="text-sm font-weight-normal">{{ row.prevRefNumber }}</td>
                                            <td class="text-sm font-weight-normal">
                                                {{ row.refNumber }}
                                            </td>
                                            <td class="text-sm font-weight-normal">
                                                {{ checkPaySide(row.paySide) }}
                                            </td>
                                            <td class="text-sm font-weight-normal">
                                                <span v-if="row.represent">
                                                    <span v-if="row.migration">
                                                        {{ checkTransaction(row.type) }} ({{
                                                            checkTransaction(row.migrationType) }},ทำแทน)
                                                    </span>
                                                    <span v-else>
                                                        {{ checkTransaction(row.type) }} (ทำแทน)
                                                    </span>
                                                </span>
                                                <span v-else-if="row.shopRepresent">
                                                    <span v-if="row.migration">
                                                        {{ checkTransaction(row.type) }} ({{
                                                            checkTransaction(row.migrationType) }},ออนไลน์)
                                                    </span>
                                                    <span v-else>
                                                        {{ checkTransaction(row.type) }} (ออนไลน์)
                                                    </span>
                                                </span>
                                                <span v-else-if="row.changeName">
                                                    <span v-if="row.migration">
                                                        {{ checkTransaction(row.type) }} ({{
                                                            checkTransaction(row.migrationType)
                                                        }},เปลี่ยนชื่อ)
                                                    </span>
                                                    <span v-else>
                                                        {{ checkTransaction(row.type) }} (เปลี่ยนชื่อ)
                                                    </span>
                                                </span>
                                                <span v-else>
                                                    <span v-if="row.migration">
                                                        {{ checkTransaction(row.type) }} ({{
                                                            checkTransaction(row.migrationType) }})
                                                    </span>
                                                    <span v-else>
                                                        {{ checkTransaction(row.type) }}
                                                    </span>
                                                </span>
                                            </td>
                                            <td class="text-sm font-weight-normal">{{
                                                formatNumberDecimalString(row.weight) }}
                                            </td>
                                            <td class="text-sm font-weight-normal">{{
                                                formatNumberDecimalString(row.quantity) }}
                                            </td>
                                            <td class="text-sm font-weight-normal">
                                                {{ formatNumberDecimalString(row.pawnValue) }}
                                            </td>

                                            <td class="text-sm font-weight-normal">{{
                                                formatNumberDecimalString(row.roundInterest) }}
                                            </td>
                                            <td class="text-sm font-weight-normal">
                                                {{ formatNumberDecimalString(row.diffValue) }}
                                            </td>
                                            <td class="text-sm font-weight-normal">
                                                {{ formatNumberDecimalString(row.payOrReceive) }}
                                            </td>
                                            <td class="text-sm font-weight-normal">
                                                <material-button color="info" variant="outline" class="rounded-circle"
                                                    :title="t('buttons.seed')" @click="openDetail(row)">
                                                    <i class="material-icons material-symbols-outlined">visibility</i>
                                                </material-button>
                                                <material-button color="info" variant="outline" class="rounded-circle"
                                                    v-show="false" data-bs-toggle="modal" data-bs-target="#lookupModal"
                                                    id="detailModal">
                                                </material-button>
                                                <material-button color="dark" variant="outline" class="rounded-circle"
                                                    :title="t('buttons.printp')" @click="ticketGen(row)"
                                                    :disabled="row.type === 'REDEEM' || row.status === 'TERMINATE'">
                                                    <i class="material-icons material-symbols-outlined">print</i>
                                                </material-button>
                                                <material-button color="secondary" variant="outline"
                                                    class="rounded-circle" data-bs-toggle="tooltip"
                                                    data-bs-placement="top" :title="t('buttons.printpb')"
                                                    @click="backCoverGen(row)"
                                                    :disabled="row.type === 'PAWN' || row.status === 'TERMINATE'">
                                                    <i class="material-icons material-symbols-outlined">description</i>
                                                </material-button>
                                                <material-button color="danger" variant="outline" class="rounded-circle"
                                                    data-bs-toggle="tooltip" data-bs-placement="top" :title="t('content.printrepltk')"
                                                    :disabled="row.prevDeposit || row.status === 'TERMINATE'" @click="replaceTicketGen(row)">
                                                    <i class="material-icons material-symbols-outlined">receipt</i>
                                                </material-button>
                                            </td>
                                        </tr>
                                        <tr v-if="listdata.length === 0">
                                            <td colspan="16" class="text-sm font-weight-normal">
                                                <p style="text-align: center">No Record Found</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="15" style="text-align: right">Total Rows : {{ totalRows_s }}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                        <pre></pre>
                        <div style="display: flex; justify-content: flex-end">
                            <ul v-show="listdata.length > 0" class="pagination justify-content-end">
                                <div class="project-container">
                                    <div class="example-one">
                                        <vue-awesome-paginate v-model="currentPage" :total-items="totalRows"
                                            :items-per-page="perPage" @click="onClickHandler" />
                                    </div>
                                </div>
                            </ul>
                        </div>
                    </div>

                    <!-- Detail Modal -->
                    <div id="lookupModal" class="modal fade" tabindex="-1" aria-labelledby="lookupModalLabel"
                        aria-hidden="true">
                        <div class="modal-dialog modal-xl modal-dialog-centered" style="max-width:1240px;">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">{{ $t("content.detail") }}</h4>
                                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                                        <i class="material-icons material-symbols-outlined">close</i>
                                    </button>
                                </div>

                                <div class="modal-body">

                                    <div class="row">
                                        <div class="col-lg-6 mt-2">
                                            <div id="lookupImages" class="carousel slide" data-bs-touch="false"
                                                data-bs-interval="false" style="max-width: 520px">
                                                <div class="carousel-indicators" id="demo1">
                                                </div>
                                                <div class="carousel-inner">
                                                    <ul className="list-unstyled">
                                                        <li v-for="(item, index) in images.length" :key="index">
                                                            <span v-if="index === 0">
                                                                <div class="carousel-item active">
                                                                    <vue-image-zoomer :regular="images[index].src"
                                                                        img-class="img-fluid" class="d-block w-100"
                                                                        :zoom-amount="3" :click-zoom="true"
                                                                        close-pos="top-right" message-pos="top" />
                                                                </div>
                                                            </span>
                                                            <span v-else>
                                                                <div class="carousel-item">
                                                                    <vue-image-zoomer :regular="images[index].src"
                                                                        img-class="img-fluid" class="d-block w-100"
                                                                        :zoom-amount="3" :click-zoom="true"
                                                                        close-pos="top-right" message-pos="top" />
                                                                </div>
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <button class="carousel-control-prev" type="button"
                                                    data-bs-target="#lookupImages" data-bs-slide="prev">
                                                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                                    <span class="visually-hidden">Previous</span>
                                                </button>
                                                <button class="carousel-control-next" type="button"
                                                    data-bs-target="#lookupImages" data-bs-slide="next">
                                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                    <span class="visually-hidden">Next</span>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 mt-2">
                                            <div v-if="workcaseDetail !== null" style="overflow-x:auto;">
                                                <div>
                                                    <table class="table table-sm table-borderless">
                                                        <tbody>
                                                            <tr>

                                                                <td class="fs-14 text-bold">{{ $t("content.ticketno") }}
                                                                    :
                                                                    <span v-if="workcaseDetail.tkRefNumber !== ''">
                                                                        {{ workcaseDetail.tkRefNumber }} &nbsp;
                                                                        <span @click='copyBtn()'
                                                                            style="cursor: pointer">
                                                                            <i
                                                                                class="inline-icon material-icons">content_copy</i>
                                                                        </span>
                                                                    </span>
                                                                    <span v-else>-</span>
                                                                </td>
                                                                <td class="fs-14 text-bold">{{ $t("content.stkeeptk") }}
                                                                    :
                                                                    <span v-if="workcaseDetail.deposit"
                                                                        style="color:green;">
                                                                        {{ $t("content.stdeposittk") }} ({{ dep_ref }})
                                                                    </span>
                                                                    <span v-else>
                                                                        -
                                                                    </span>
                                                                </td>

                                                            </tr>
                                                            <tr>
                                                                <td class="fs-14 text-bold">{{ $t("content.trans") }} :
                                                                    {{ checkTransaction(workcaseDetail.transactionType)
                                                                    }}
                                                                </td>
                                                                <td class="fs-14 text-bold">{{
                                                                    $t("content.statusticket") }} :
                                                                    <span v-if="workcaseDetail.status === 'FINISH'"
                                                                        style="color:green;">
                                                                        {{ tk_status }}
                                                                    </span>
                                                                    <span v-else-if="workcaseDetail.status === 'FREEZE' || workcaseDetail.status === 'TERMINATE'
                                                                        || workcaseDetail.status === 'BREAKING'"
                                                                        style="color:red;">
                                                                        <span
                                                                            v-if="workcaseDetail.status === 'BREAKING'">
                                                                            {{ tk_status }} ({{
                                                                                format_date(workcaseDetail.breakingDate) }}
                                                                            : {{
                                                                                workcaseDetail.lotNumber }})
                                                                        </span>
                                                                        <span v-else>
                                                                            {{ tk_status }}
                                                                        </span>
                                                                    </span>
                                                                    <span v-else>
                                                                        {{ tk_status }}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr v-if="workcaseDetail.postponeCount === 0">
                                                                <td class="fs-14 text-bold"> {{ $t("content.lasttrf") }}
                                                                    : {{
                                                                        format_datetime(workcaseDetail.workItems[0].startTime)
                                                                    }}</td>
                                                                <td class="fs-14 text-bold">
                                                                    {{ $t("content.amnduedate") }} :
                                                                    <span style="color:red;">
                                                                        {{ format_date(workcaseDetail.dueDate) }}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr v-if="workcaseDetail.postponeCount !== 0">
                                                                <td class="fs-14 text-bold" colspan="2"> {{
                                                                    $t("content.lasttrf") }} : {{
                                                                        format_datetime(workcaseDetail.workItems[0].startTime)
                                                                    }}</td>
                                                            </tr>
                                                            <tr v-if="workcaseDetail.postponeCount !== 0">
                                                                <td class="fs-14 text-bold" colspan="2">
                                                                    {{ $t("content.amnduedate") }} :
                                                                    <span style="color:red;">
                                                                        {{ format_date(workcaseDetail.dueDate) }}
                                                                        (ขอเลื่อนเป็นวันที่ {{
                                                                            format_date(workcaseDetail.postponeDate) }})
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr v-if="workcaseDetail.postponeCount !== 0">
                                                                <td class="fs-14 text-bold" colspan="2">
                                                                    {{ $t("content.deferpast") }} :
                                                                    <span @click='NewTab()'
                                                                        style="text-decoration: underline;color:red; cursor: pointer">
                                                                        {{ workcaseDetail.postponeCount }}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="fs-14 text-bold">
                                                                    {{ $t("content.monthlyprofn") }} : {{
                                                                        formatNumberDecimalString(workcaseDetail.interestPerMonth)
                                                                    }}
                                                                    <span style="color:red;">
                                                                        ({{ format_date(new Date()) }})
                                                                    </span>
                                                                </td>
                                                                <td class="fs-14 text-bold">
                                                                    {{ $t("content.currentprof") }} :
                                                                    <span style="color:red;">
                                                                        {{ formatNumberDecimalString(int_cal) }}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="fs-14 text-bold">
                                                                    {{ $t("content.prointerestn") }} :
                                                                    <span
                                                                        v-if="workcaseDetail.interestPromotion === null || workcaseDetail.interestPromotion === 0">
                                                                        -
                                                                    </span>
                                                                    <span style="color:blue;" v-else>
                                                                        {{
                                                                            formatNumberDecimalString(workcaseDetail.interestPromotion)
                                                                        }}
                                                                    </span>
                                                                </td>
                                                                <td class="fs-14 text-bold">
                                                                    {{ $t("content.periodpromotion") }} :
                                                                    <span v-if="workcaseDetail.promotionDuration === 0">
                                                                        -
                                                                    </span>
                                                                    <span style="color:blue;" v-else>
                                                                        {{ workcaseDetail.promotionDuration }} เดือน
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="fs-14 text-bold">{{ $t("content.periodpawnn")
                                                                    }} :
                                                                    <span style="color:blue;">
                                                                        {{ int_period }} เดือน
                                                                    </span>
                                                                </td>
                                                                <td class="fs-14 text-bold">{{ $t("content.amnbookno")
                                                                    }}
                                                                    <span style="color:blue;">
                                                                        {{ workcaseDetail.tkVolNo }}
                                                                    </span>
                                                                    &nbsp;{{ $t("content.amnno") }}
                                                                    <span style="color:blue;">
                                                                        {{ workcaseDetail.tkNo }}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="fs-14 text-bold">{{ $t("content.amnqtypiece")
                                                                    }} :
                                                                    {{
                                                                        formatNumberString(workcaseDetail.ticket.totalQuantity)
                                                                    }}
                                                                </td>
                                                                <td class="fs-14 text-bold">{{ $t("content.allweight")
                                                                    }} :
                                                                    {{
                                                                        formatNumberDecimalString(workcaseDetail.ticket.totalWeight)
                                                                    }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="fs-14 text-bold">{{ $t("content.pawnvalpv")
                                                                    }} :
                                                                    <span
                                                                        v-if="workcaseDetail.transactionType === 'PAWN'">
                                                                        {{ formatNumberDecimalString(0) }}
                                                                    </span>
                                                                    <span v-else>
                                                                        {{
                                                                            formatNumberDecimalString(workcaseDetail.pawnValue)
                                                                        }}
                                                                    </span>
                                                                </td>
                                                                <td class="fs-14 text-bold">{{ $t("content.actpawn3")
                                                                    }}/{{ $t("content.actpawn4") }} :
                                                                    {{
                                                                        formatNumberDecimalString(workcaseDetail.diffValue)
                                                                    }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="fs-14 text-bold">{{
                                                                    $t("content.amnanalysval") }} :
                                                                    {{
                                                                        formatNumberDecimalString(workcaseDetail.newPawnValue)
                                                                    }}
                                                                </td>
                                                                <td class="fs-14 text-bold">{{
                                                                    $t("content.amnmaxvalall") }} :
                                                                    {{
                                                                        formatNumberDecimalString(workcaseDetail.ticket.totalFullValue)
                                                                    }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="fs-14 text-bold">{{
                                                                    $t("content.statusticketlost") }} :
                                                                    <span v-if="workcaseDetail.lostCount === 0"
                                                                        style="color:green;"> ไม่มี
                                                                    </span>
                                                                    <span v-else style="color:red;">
                                                                        มี ({{ workcaseDetail.lostCount }})
                                                                    </span>
                                                                </td>
                                                                <td class="fs-14 text-bold">{{ $t("content.refnolost")
                                                                    }} :
                                                                    <span v-if="workcaseDetail.lostCount === 0"
                                                                        style="color:green;"> -
                                                                    </span>
                                                                    <span v-else style="color:red;">
                                                                        {{ workcaseDetail.lostRefNumber }}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr
                                                                v-if="workcaseDetail.represent || workcaseDetail.shopRepresent">
                                                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.represent") }} :
                                                                    <span style="color:red;">
                                                                    {{workcaseDetail.customerInfo.name}}
                                                                     </span>
                                                                </td>
                                                            </tr>
                                                            <tr v-if="workcaseDetail.changeName">
                                                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.changeName") }} ({{ bf_changename }}) :
                                                                    <span style="color:red;">
                                                                    {{ af_changename }}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="fs-14 text-bold" colspan="2"> {{ $t("content.transoutage") }} :
                                                                    <span v-if="workcaseDetail.outage" style="color:red">
                                                                    {{ $t("content.yes") }}
                                                                    </span>
                                                                    <span v-else style="color:green">
                                                                    {{ $t("content.no") }}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="fs-14 text-bold" colspan="2"> {{
                                                                    $t("content.amnlocationasset") }} :
                                                                    <span
                                                                        v-if="workcaseDetail.ticket.locationName !== null">
                                                                        {{ workcaseDetail.ticket.locationName }}
                                                                    </span>
                                                                    <span v-else>
                                                                        -
                                                                    </span>

                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="fs-14 text-bold" colspan="2"> {{
                                                                    $t("content.stockno") }} :
                                                                    <span
                                                                        v-if="workcaseDetail.ticket.stockNumber !== null">
                                                                        {{ workcaseDetail.ticket.stockNumber }}
                                                                    </span>
                                                                    <span v-else>
                                                                        -
                                                                    </span>

                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td class="fs-14 text-bold" colspan="2"> {{
                                                                    $t("content.migraref") }} :
                                                                    <span
                                                                        v-if="workcaseDetail.migrateRefNumber !== null">
                                                                        {{ workcaseDetail.migrateRefNumber }}
                                                                    </span>
                                                                    <span v-else>
                                                                        -
                                                                    </span>

                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <span v-if="listinfo.length !== 0">
                                                        <table class="table table-sm table-borderless">
                                                            <tbody>
                                                                <tr>
                                                                    <td class="fs-14 text-bold">
                                                                        <span style="text-decoration:underline;">
                                                                            {{ $t("content.amnassetdetail") }}
                                                                        </span>
                                                                    </td>
                                                                </tr>

                                                                <tr v-for="(row, index) in listinfo" :key="index">
                                                                    <td class="fs-14 text-bold">
                                                                        {{ formatNumberString(index + 1) }}. {{
                                                                            row.remark }}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>

                                                    </span>
                                                    <span v-else>
                                                        <tr>
                                                            <td class="fs-14 text-bold">
                                                                <span style="text-decoration:underline;">
                                                                    {{ $t("content.amnassetdetail") }}
                                                                </span>
                                                                : -
                                                            </td>

                                                        </tr>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr v-if="paymentE !== ''" />
                                    <div class="col-12 mt-2" v-if="paymentE !== ''">
                                        <div class="fs-14 text-bold">
                                            <span style="text-decoration:underline;">
                                                {{ $t("content.amnfinanceinfo") }}
                                            </span>
                                        </div>
                                        <pre></pre>
                                        <div class="row">
                                            <div class="table-responsive">
                                                <table class="table table-flush">
                                                    <thead class="thead-light">
                                                        <tr>
                                                            <th>#</th>
                                                            <th>{{ $t("content.ticketno") }}</th>
                                                            <th>{{ $t("content.amnbiz") }}</th>
                                                            <th colspan="5" class="align-top text-center"
                                                                style="background-color:#dfffdd;">
                                                                <span style="color:black;">
                                                                    {{ $t("content.amnincome") }}
                                                                </span>
                                                            </th>
                                                            <th colspan="4" class="align-top text-center"
                                                                style="background-color:#fecac7;">
                                                                <span style="color:black;">
                                                                    {{ $t("content.amnoutcome") }}
                                                                </span>
                                                            </th>
                                                            <th colspan="4" class="align-top text-center"
                                                                style="background-color:#CFEBFD;">
                                                                <span style="color:black;">
                                                                    {{ $t("content.fee") }}
                                                                </span>
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="3"></th>
                                                            <th class="align-top text-center"
                                                                style="background-color:#dfffdd;">
                                                                <span style="color:black;">
                                                                    {{ $t("content.amncash") }}
                                                                </span>
                                                            </th>
                                                            <th colspan="2" class="align-top text-center"
                                                                style="background-color:#dfffdd;">
                                                                <span style="color:black;">
                                                                    {{ $t("content.amnbanktransfer") }}
                                                                </span>
                                                            </th>
                                                            <th class="align-top text-center"
                                                                style="background-color:#dfffdd;">
                                                                <span style="color:black;">
                                                                    {{ $t("content.amncreditcard") }}
                                                                </span>

                                                            </th>
                                                            <th class="align-top text-center"
                                                                style="background-color:#dfffdd;">
                                                                <span style="color:black;">
                                                                    {{ $t("content.amncheque") }}
                                                                </span>
                                                            </th>
                                                            <th class="align-top text-center"
                                                                style="background-color:#fecac7;">
                                                                <span style="color:black;">
                                                                    {{ $t("content.amncash") }}
                                                                </span>
                                                            </th>
                                                            <th colspan="3" class="align-top text-center"
                                                                style="background-color:#fecac7;">
                                                                <span style="color:black;">
                                                                    {{ $t("content.amnbanktransfer") }}
                                                                </span>
                                                            </th>
                                                            <th class="align-top text-center"
                                                                style="background-color:#CFEBFD;">
                                                                <span style="color:black;">
                                                                    {{ $t("content.amncash") }}
                                                                </span>
                                                            </th>
                                                            <th colspan="2" class="align-top text-center"
                                                                style="background-color:#CFEBFD;">
                                                                <span style="color:black;">
                                                                    {{ $t("content.amnbanktransfer") }}
                                                                </span>
                                                            </th>
                                                            <th class="align-top text-center"
                                                                style="background-color:#CFEBFD;">
                                                                <span style="color:black;">
                                                                    {{ $t("content.amncreditcard") }}
                                                                </span>
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th colspan="3"></th>
                                                            <th style="background-color:#dfffdd;"></th>
                                                            <th class="align-top text-center"
                                                                style="background-color:#dfffdd;">
                                                                <span style="color:black;">
                                                                    {{ $t("content.amnbankacc") }}
                                                                </span>
                                                            </th>
                                                            <th class="align-top text-center"
                                                                style="background-color:#dfffdd;">
                                                                <span style="color:black;">
                                                                    QR Code
                                                                </span>
                                                            </th>
                                                            <th colspan="2" style="background-color:#dfffdd;"></th>
                                                            <th style="background-color:#fecac7;"></th>
                                                            <th class="align-top text-center"
                                                                style="background-color:#fecac7;">
                                                                <span style="color:black;">
                                                                    {{ $t("content.amnbankacc") }}
                                                                </span>
                                                            </th>
                                                            <th class="align-top text-center"
                                                                style="background-color:#fecac7;">
                                                                <span style="color:black;">
                                                                    {{ $t("content.amntransfer_promt_mobile") }}
                                                                </span>
                                                            </th>
                                                            <th class="align-top text-center"
                                                                style="background-color:#fecac7;">
                                                                <span style="color:black;">
                                                                    {{ $t("content.amntransfer_promt_taxid") }}
                                                                </span>
                                                            </th>
                                                            <th style="background-color:#CFEBFD;"></th>
                                                            <th class="align-top text-center"
                                                                style="background-color:#CFEBFD;">
                                                                <span style="color:black;">
                                                                    {{ $t("content.amnbankacc") }}
                                                                </span>
                                                            </th>
                                                            <th class="align-top text-center"
                                                                style="background-color:#CFEBFD;">
                                                                <span style="color:black;">
                                                                    QR Code
                                                                </span>
                                                            </th>
                                                            <th style="background-color:#CFEBFD;"></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(row, index) in paymentE.workCases" :key="index">
                                                            <template v-if="row.ticket !== null">
                                                                <td class="text-sm font-weight-normal text-center">{{
                                                                    formatNumberString(index + 1) }}
                                                                </td>
                                                                <td class="text-sm font-weight-normal text-center">{{
                                                                    row.tkRefNumber }}</td>
                                                                <td class="text-sm font-weight-normal text-center">{{
                                                                    checkTransaction(row.transactionType) }}</td>
                                                                <td v-if="index == 0"
                                                                    class="text-sm font-weight-normal text-center"
                                                                    :rowspan="paymentE.workCases.length">
                                                                    <span v-if="payment_l[0].receive > 0"
                                                                        style="color:green;">
                                                                        {{
                                                                            formatNumberDecimalString(payment_l[0].receive)
                                                                        }}
                                                                    </span>
                                                                    <span v-else>
                                                                        -
                                                                    </span>
                                                                </td>
                                                                <td v-if="index == 0"
                                                                    class="text-sm font-weight-normal text-center"
                                                                    :rowspan="paymentE.workCases.length">
                                                                    <span v-if="payment_l[1].receive > 0"
                                                                        style="color:green;">
                                                                        {{
                                                                            formatNumberDecimalString(payment_l[1].receive)
                                                                        }}
                                                                    </span>
                                                                    <span v-else>
                                                                        -
                                                                    </span>
                                                                </td>
                                                                <td v-if="index == 0"
                                                                    class="text-sm font-weight-normal text-center"
                                                                    :rowspan="paymentE.workCases.length">
                                                                    <span v-if="payment_l[6].receive > 0"
                                                                        style="color:green;">
                                                                        {{
                                                                            formatNumberDecimalString(payment_l[6].receive)
                                                                        }}
                                                                    </span>
                                                                    <span v-else>
                                                                        -
                                                                    </span>
                                                                </td>
                                                                <td v-if="index == 0"
                                                                    class="text-sm font-weight-normal text-center"
                                                                    :rowspan="paymentE.workCases.length">
                                                                    <span v-if="payment_l[2].receive > 0"
                                                                        style="color:green;">
                                                                        {{
                                                                            formatNumberDecimalString(payment_l[2].receive)
                                                                        }}
                                                                    </span>
                                                                    <span v-else>
                                                                        -
                                                                    </span>
                                                                </td>
                                                                <td v-if="index == 0"
                                                                    class="text-sm font-weight-normal text-center"
                                                                    :rowspan="paymentE.workCases.length">
                                                                    <span v-if="payment_l[3].receive > 0"
                                                                        style="color:green;">
                                                                        {{
                                                                            formatNumberDecimalString(payment_l[3].receive)
                                                                        }}
                                                                    </span>
                                                                    <span v-else>
                                                                        -
                                                                    </span>
                                                                </td>
                                                                <td v-if="index == 0"
                                                                    class="text-sm font-weight-normal text-center"
                                                                    :rowspan="paymentE.workCases.length">
                                                                    <span v-if="payment_l[0].pay > 0"
                                                                        style="color:red;">
                                                                        {{ formatNumberDecimalString(payment_l[0].pay)
                                                                        }}
                                                                    </span>
                                                                    <span v-else>
                                                                        -
                                                                    </span>
                                                                </td>
                                                                <td v-if="index == 0"
                                                                    class="text-sm font-weight-normal text-center"
                                                                    :rowspan="paymentE.workCases.length">
                                                                    <span v-if="payment_l[1].pay > 0"
                                                                        style="color:red;">
                                                                        {{ formatNumberDecimalString(payment_l[1].pay)
                                                                        }}
                                                                    </span>
                                                                    <span v-else>
                                                                        -
                                                                    </span>
                                                                </td>
                                                                <td v-if="index == 0"
                                                                    class="text-sm font-weight-normal text-center"
                                                                    :rowspan="paymentE.workCases.length">
                                                                    <span v-if="payment_l[4].pay > 0"
                                                                        style="color:red;">
                                                                        {{ formatNumberDecimalString(payment_l[4].pay)
                                                                        }}
                                                                    </span>
                                                                    <span v-else>
                                                                        -
                                                                    </span>
                                                                </td>
                                                                <td v-if="index == 0"
                                                                    class="text-sm font-weight-normal text-center"
                                                                    :rowspan="paymentE.workCases.length">
                                                                    <span v-if="payment_l[5].pay > 0"
                                                                        style="color:red;">
                                                                        {{ formatNumberDecimalString(payment_l[5].pay)
                                                                        }}
                                                                    </span>
                                                                    <span v-else>
                                                                        -
                                                                    </span>
                                                                </td>
                                                                <td v-if="index == 0"
                                                                    class="text-sm font-weight-normal text-center"
                                                                    :rowspan="paymentE.workCases.length">
                                                                    <span v-if="payment_l[0].fee > 0"
                                                                        style="color:blue;">
                                                                        {{ formatNumberDecimalString(payment_l[0].fee)
                                                                        }}
                                                                    </span>
                                                                    <span v-else>
                                                                        -
                                                                    </span>
                                                                </td>
                                                                <td v-if="index == 0"
                                                                    class="text-sm font-weight-normal text-center"
                                                                    :rowspan="paymentE.workCases.length">
                                                                    <span v-if="payment_l[1].fee > 0"
                                                                        style="color:blue;">
                                                                        {{ formatNumberDecimalString(payment_l[1].fee)
                                                                        }}
                                                                    </span>
                                                                    <span v-else>
                                                                        -
                                                                    </span>
                                                                </td>
                                                                <td v-if="index == 0"
                                                                    class="text-sm font-weight-normal text-center"
                                                                    :rowspan="paymentE.workCases.length">
                                                                    <span v-if="payment_l[6].fee > 0"
                                                                        style="color:blue;">
                                                                        {{ formatNumberDecimalString(payment_l[6].fee)
                                                                        }}
                                                                    </span>
                                                                    <span v-else>
                                                                        -
                                                                    </span>
                                                                </td>
                                                                <td v-if="index == 0"
                                                                    class="text-sm font-weight-normal text-center"
                                                                    :rowspan="paymentE.workCases.length">
                                                                    <span v-if="payment_l[2].fee > 0"
                                                                        style="color:blue;">
                                                                        {{ formatNumberDecimalString(payment_l[2].fee)
                                                                        }}
                                                                    </span>
                                                                    <span v-else>
                                                                        -
                                                                    </span>
                                                                </td>
                                                            </template>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
/* eslint-disable no-unused-vars */
import ProgressSpinner from 'primevue/progressspinner';
import { reactive, ref, computed, onMounted, inject, onUpdated } from "vue";
import { useI18n } from "vue-i18n";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import ExampleFive from "@/examples/ExampleOne";
import MaterialButton from "@/components/MaterialButton.vue";
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";

import axios from "axios";
import * as st from "@/config/setting.js";
import moment from 'moment'
import noImg from "@/assets/img/noimg.png"

import { useWorkCaseStore } from '@/stores/workcase'
import { useCashAccountStore } from '@/stores/cashaccount'
import { useInterestStore } from '@/stores/interest'
import { usePaymentGroupStore } from '@/stores/paymentgroup'
import { useDepositStore } from '@/stores/deposit'


const storewc = useWorkCaseStore()
const storeca = useCashAccountStore()
const storei = useInterestStore()
const storepay = usePaymentGroupStore()
const storedepo = useDepositStore()

const { t } = useI18n();
const swal = inject("$swal");

const shop_detail = ref(null)
const listdata = ref([])
const start_date = ref(new Date(new Date().setHours(0, 0, 0)));
const end_date = ref(new Date(new Date().setHours(23, 59, 59)));
const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(30);
const totalRows_s = ref();
const allTk = ref(false);

const workcaseDetail = ref(null);
const info_cat = ref('');
const int_cal = ref(0);
const tk_status = ref('');
const int_period = ref('');
const listinfo = ref([])
const images = ref([])
const images_l = ref([])
const payment_l = ref([])
const paymentE = ref('');
const loading = ref(false);
const dep_ref = ref('');
const bf_changename = ref('');
const af_changename = ref('');

const format = (date) => {
    return moment(String(date)).local().format('DD/MM/YYYY HH:mm');
}

const textInputOptions = {
    format: 'dd/MM/yyyy HH:mm'
};

const onClickHandler = () => {
    updatePagination()
};

const InfoFromSession = async (val) => {
    shop_detail.value = null
    const response = await storeca.cashaccountInfoFromSessionFetch();
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                shop_detail.value = response.data.data
                await getOnlineList()
            }
        }
    }
}

InfoFromSession()

function copyBtn() {
    navigator.clipboard.writeText(workcaseDetail.value.tkRefNumber);
}

const NewTab = async () => {
    sessionStorage.removeItem('deferWorkcaseUid');
    sessionStorage.setItem("deferWorkcaseUid", workcaseDetail.value.uid);
    if (sessionStorage.getItem('deferWorkcaseUid') !== null) {
        const win = window.open("#/generals/defer_items", "_blank");
        win.focus();
        sessionStorage.removeItem('deferWorkcaseUid');
    }
}

function format_datetime(value) {
    if (value) {
        return moment(String(value)).local().format('DD/MM/YYYY HH:mm:ss')
    }
}

function format_date(value) {
    if (value) {
        return moment(String(value)).local().format('DD/MM/YYYY')
    }
}


function formatNumberString(num) {
    return String(num).replace(
        /(\d)(?=(\d{3})+(?!\d))/g,
        "$1,"
    );
}

function formatNumberDecimalString(num) {
    if (num !== null && num !== undefined) {
        num = num.toFixed(2)
    } else {
        num = 0
        num = num.toFixed(2)
    }
    return String(num).replace(
        /(\d)(?=(\d{3})+(?!\d))/g,
        "$1,"
    );
}

function cancelBtn() {
    start_date.value = new Date(new Date().setHours(0, 0, 0));
    end_date.value = new Date(new Date().setHours(23, 59, 59));
    listdata.value = [];
    allTk.value = false
    totalRows_s.value = ''
    currentPage.value = 1
    getOnlineList()
}

function checkTransaction(str) {
    // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
    let side = ''
    if (str === 'PAWN') {
        side = 'จำนำ'
    } else if (str === 'INTEREST') {
        side = 'ต่อดอกเบี้ย'
    } else if (str === 'REDEEM') {
        side = 'ไถ่ถอน'
    } else if (str === 'INC_PRINCIPLE') {
        side = 'เพิ่มต้น'
    } else if (str === 'DEC_PRINCIPLE') {
        side = 'ลดต้น'
    }
    return side
}

function checkPaySide(str) {
    // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE

    let side = ''
    if (str === 'PAY') {
        side = 'จ่ายเงิน'
    } else if (str === 'RECEIVE') {
        side = 'รับเงิน'
    } else if (str === 'NONE') {
        side = 'ไม่มียอด'
    }
    return side
}

async function getOnlineList() {
    let data = "";
    data = {
        index: currentPage.value - 1,
        size: perPage.value,
        groupUid: shop_detail.value.groupUid,
        shopUid: shop_detail.value.uid,
        cusUid: '',
        refNumber: '',
        fromDate: moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss'),
        toDate: moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59'),
        channel: 'LINE_LIFF', // SHOP, LINE_LIFF, MOB_ANDROID, MOB_IOS, WEB
        status: 'ACTIVE,FINISH', // ACTIVE,FINISH
    };
    const payload = data;
    // console.log("ld p : " + JSON.stringify(payload));
    const response = await storewc.workCaselistExFetch(payload);
    // console.log("ld r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                let listd = response.data.data.list;
                listd.map(function (x) {
                    x.chk = false;
                    return x
                });
                listdata.value = listd
                totalRows.value = response.data.data.ext.total
                totalRows_s.value = formatNumberString(totalRows.value)
            }
        }
    }
}

async function updatePagination() {
    listdata.value = [];
    let data = "";
    data = {
        index: currentPage.value - 1,
        size: perPage.value,
        groupUid: shop_detail.value.groupUid,
        shopUid: shop_detail.value.uid,
        cusUid: '',
        refNumber: '',
        fromDate: moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss'),
        toDate: moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59'),
        channel: 'LINE_LIFF', // SHOP, LINE_LIFF, MOB_ANDROID, MOB_IOS, WEB
        status: 'ACTIVE,FINISH', // ACTIVE,FINISH
    };
    const payload = data;
    // console.log("ld p : " + JSON.stringify(payload));
    const response = await storewc.workCaselistExFetch(payload);
    // console.log("ld r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                let listd = response.data.data.list;
                listd.map(function (x) {
                    x.chk = false;
                    return x
                });
                listdata.value = listd
                totalRows.value = response.data.data.ext.total
                totalRows_s.value = formatNumberString(totalRows.value)
            }
        }
    }
}

async function openDetail(item) {
    workcaseDetail.value = null
    images.value = []
    images_l.value = []
    listinfo.value = []
    info_cat.value = ''
    tk_status.value = ''
    int_cal.value = 0
    paymentE.value = ''
    int_period.value = ''
    dep_ref.value = ''
    bf_changename.value = ''
    af_changename.value = ''

    await getworkCaseInfo(item.uid)
    if (workcaseDetail.value != null) {
        // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value));
        if (workcaseDetail.value.changeName) {
            af_changename.value = workcaseDetail.value.tkCustomerInfo.name 
            await getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
        }

        if (workcaseDetail.value.deposit) {
            await getDepositInfo(workcaseDetail.value.tkRefNumber)
        }

        await detailPayment(workcaseDetail.value.paymentGroupUid)

        images_l.value = workcaseDetail.value.ticket.images
        listinfo.value = workcaseDetail.value.ticket.collaterals
        await calIntInt();
        if (workcaseDetail.value.transactionType !== 'REDEEM') {

            if (workcaseDetail.value.status === 'FINISH') {
                tk_status.value = 'ปกติ'
            } else if (workcaseDetail.value.status === 'FREEZE') {
                tk_status.value = 'อายัด'
            } else if (workcaseDetail.value.status === 'TERMINATE') {
                tk_status.value = 'ยกเลิก'
            } else if (workcaseDetail.value.status === 'ACTIVE') {
                tk_status.value = 'กำลังดำเนินการ'
            } else if (workcaseDetail.value.status === 'BREAKING') {
                tk_status.value = 'ของหลุด'
            }

        } else {
            if (workcaseDetail.value.status === 'FINISH') {
                tk_status.value = 'ไถ่ถอน'
            } else if (workcaseDetail.value.status === 'TERMINATE') {
                tk_status.value = 'ยกเลิก'
            }
        }
        if (images_l.value.length > 0) {
            getTicketImage()
        } else {
            let obj = {
                src: noImg,
                thumbnailImageSrc: noImg,
                alt: '',
                title: ''
            }
            images.value.push(obj)
            setGallery()
            document.getElementById("detailModal").click();
        }
    }
}

function setGallery() {

    var i, y = "";

    for (i = 0; i < images.value.length; i++) {
        if (i == 0) {
            y = y + '<button type = "button" data-bs-target="#lookupImages" data-bs-slide-to="' + String(i) + '"' +
                ' class="active" aria-current="true" aria-label="Slide ' + Number(i + 1) + '"> </button >';
        } else {
            y = y + '<button type = "button" data-bs-target="#lookupImages" data-bs-slide-to="' + String(i) + '"' +
                ' aria-label="Slide ' + Number(i + 1) + '"> </button >';
        }

    }
    document.getElementById("demo1").innerHTML = y;
}


async function getworkCaseInfo(id) {
    let data = "";
    data = {
        uid: id,
    };
    const payload = data;

    const response = await storewc.workCaseinfoFetch(payload);
    // console.log("workCaseInfo : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                workcaseDetail.value = response.data.data
            }
        }
    }
}

async function calIntInt() {
    let postponeDate = ''
    if (workcaseDetail.value.postponeCount != 0) {
        postponeDate = moment(workcaseDetail.value.postponeDate).format('YYYY-MM-DD')
    }
    let data = "";
    let pawnValue = 0
    if (workcaseDetail.value.transactionType != 'REDEEM') {
        pawnValue = workcaseDetail.value.newPawnValue
    } else {
        pawnValue = workcaseDetail.value.pawnValue
    }
    data = {
        pawnDate: moment(workcaseDetail.value.workItems[0].startTime).format('YYYY-MM-DD'),
        previousTxDate: '',
        postponeDate: postponeDate,
        pawnValue: pawnValue,
        promotionUid: workcaseDetail.value.promotionUid,
        interestUid: workcaseDetail.value.interestUid,
    };
    const payload = data;
    // console.log("calIntInt p : " + JSON.stringify(payload));
    const response = await storei.interestCalculateFetch(payload);
    // console.log("calIntInt r : " + JSON.stringify(response.data));
    let res = ''
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                res = response.data.data
                int_cal.value = Number(res.overdueInterest) + Number(res.dueInterest)
                int_period.value = res.interestPeriod
            }
        }
    }
}

async function detailPayment(item) {
    // console.log('detailPayment : ' + item);
    let data = "";
    data = {
        uid: item,
    };
    const payload = data;
    const response = await storepay.paymentGroupinfoFetch(payload);

    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                paymentE.value = response.data.data
                filterPayType()
                // console.log('detailPayment : ' + JSON.stringify(paymentE.value));
            }
        }
    }
}

function filterPayType() {
    payment_l.value = []
    let pt = [{ name: 'CASH' },
    { name: 'BANK_TRANSFER' },
    { name: 'CREDIT_CARD' },
    { name: 'CHEQUE' },
    { name: 'PROMPT_PAY_MOBILE' },
    { name: 'PROMPT_PAY_TAX_ID' },
    { name: 'QR_CODE' },
    ]
    let lsum = []
    for (let i = 0; i < pt.length; i++) {
        lsum = filterSumPay(pt[i].name)
        if (lsum.length > 0) {
            payment_l.value.push({ name: pt[i].name, pay: lsum[0].pay, receive: lsum[0].receive, fee: lsum[0].fee })
        } else {
            payment_l.value.push({ name: pt[i].name, pay: 0, receive: 0, fee: 0 })
        }
    }
}

function filterSumPay(str) {
    let nump = 0, numr = 0, numf = 0
    let lp = paymentE.value.payments.filter((c) => c.type === str);
    if (lp.length > 0) {
        let pay = 0
        let receive = 0
        let fee = 0
        for (let i = 0; i < lp.length; i++) {
            pay = pay + lp[i].pay
            receive = receive + lp[i].receive
            fee = fee + lp[i].feeReceive
            // fee = fee + lp[i].fee
        }
        nump = pay
        numr = receive
        numf = fee
    }
    let lockL = []
    lockL.push({ pay: nump, receive: numr, fee: numf })
    // console.log('lockL : ' + JSON.stringify(lockL));
    return lockL
}

async function getTicketImage() {
    if (images.value.length === 0) {
        let url = []
        images.value = []
        for (let i = 0; i < images_l.value.length; i++) {
            if (images_l.value[i].imageUid !== "0") {
                url.push(String(st.url_api + "/doc-svc/document/info/" + images_l.value[i].imageUid));
            }
        }
        if (url.length > 0) {
            await getFile(url)
            if (images.value.length > 0) {
                setGallery()
                document.getElementById("detailModal").click();

            } else {
                let obj = {
                    src: noImg,
                    thumbnailImageSrc: noImg,
                    alt: '',
                    title: ''
                }
                images.value.push(obj)
                setGallery()
                document.getElementById("detailModal").click();

            }
        } else {
            let obj = {
                src: noImg,
                thumbnailImageSrc: noImg,
                alt: '',
                title: ''
            }
            images.value.push(obj)
            setGallery()
            document.getElementById("detailModal").click();

        }
    } else {
        setGallery()
        document.getElementById("detailModal").click();

    }
}

async function getFile(urls) {
    let file_L = []
    const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
    const accessToken = key.accessToken;
    axios.defaults.headers["Authorization"] = `Bearer ${accessToken}`;
    const requests = urls.map((url) => axios.get(url));
    await Promise.all(requests).then(allResults => {
        if (allResults) {
            file_L = allResults
            if (file_L !== null) {
                for (let i = 0; i < file_L.length; i++) {
                    // console.log('file_L : ' + JSON.stringify(file_L[i].data));
                    if (file_L[i].data.data !== null) {
                        const file = getFileFromBase64(file_L[i].data.data.data, file_L[i].data.data.name)
                        const data = URL.createObjectURL(file);
                        let obj = {
                            src: data,
                            thumbnailImageSrc: data,
                            alt: '',
                            title: ''
                        }
                        images.value.push(obj)
                    }
                }
            }
        }
    })
}


function getFileFromBase64(string64, fileName) {
    const trimmedString = string64.replace('dataimage/jpegbase64', '');
    const imageContent = atob(trimmedString);
    const buffer = new ArrayBuffer(imageContent.length);
    const view = new Uint8Array(buffer);

    for (let n = 0; n < imageContent.length; n++) {
        view[n] = imageContent.charCodeAt(n);
    }
    var ext = fileName.split('.').pop();
    let type = '';
    if (ext === 'jpg') {
        type = 'image/jpeg'
    } else if (ext === 'png') {
        type = 'image/png'
    }
    const blob = new Blob([buffer], { type });
    return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}

async function setAllTk() {
    for (let i = 0; i < listdata.value.length; i++) {
        if (allTk.value) {
            listdata.value[i].chk = true
        } else {
            listdata.value[i].chk = false
        }
    }
}

async function setTk(item) {
    if (item.chk === false) {
        if (allTk.value) {
            allTk.value = false
        }
    } else if (item.chk === true) {
        let ck = true
        for (let i = 0; i < listdata.value.length; i++) {
            if (listdata.value[i].chk === false) {
                ck = false
                break
            }
        }
        if (ck) {
            allTk.value = true
        } else {
            allTk.value = false
        }
    }
}


async function ticketGen(item) {
    let uids = []
    uids.push(item.uid)
    await getticketNew(uids)
}

async function backCoverGen(item) {
    let uids = []
    uids.push(item.uid)
    await getbackcoverNew(uids)
}

async function replaceTicketGen(item) {
    let uids = []
    uids.push(item.prevUid)
    await getreplaceTicketNew(uids)
}

async function ticketListGen() {
    let uids = []
    for (let i = 0; i < listdata.value.length; i++) {
        if (listdata.value[i].chk && listdata.value[i].status !== 'TERMINATE' && listdata.value[i].type !== 'REDEEM') {
            uids.push(listdata.value[i].uid)
        }
    }
    if (uids.length === 0) {
        swal("กรุณาเลือกรายการ", "", "warning");
        return
    } else {
        await getticketNew(uids)
    }

}

async function backCoverListGen() {
    let uids = []
    for (let i = 0; i < listdata.value.length; i++) {
        if (listdata.value[i].chk && listdata.value[i].status !== 'TERMINATE' && listdata.value[i].type !== 'PAWN') {
            uids.push(listdata.value[i].uid)
        }
    }
    if (uids.length === 0) {
        swal("กรุณาเลือกรายการ", "", "warning");
        return
    } else {
        await getbackcoverNew(uids)
    }
}

async function replaceTicketListGen() {
    let uids = []
    for (let i = 0; i < listdata.value.length; i++) {
        if (listdata.value[i].chk && listdata.value[i].status !== 'TERMINATE' && listdata.value[i].prevDeposit === false) {
            uids.push(listdata.value[i].prevUid)
        }
    }
    if (uids.length === 0) {
        swal("กรุณาเลือกรายการ", "", "warning");
        return
    } else {
        await getreplaceTicketNew(uids)
    }
}


async function getticketNew(id) {
    loading.value = true
    let data = {
        groupUid: shop_detail.value.groupUid,
        shopUid: shop_detail.value.uid,
        uids: id
    };
    const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
    const accessToken = key.accessToken;
    const response = await axios({
        method: 'POST',
        data: data,
        url: st.url_api + `/docgen-svc/ticket/pdf`,
        headers: { Authorization: `Bearer ${accessToken}` },
        responseType: 'arraybuffer',
    });
    loading.value = false
    if (response.headers.get("content-type") === 'application/pdf') {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank').focus();
    } else {
        swal("โหลด PDF ไม่สำเร็จ", "", "error");
    }
}

async function getbackcoverNew(id) {
    loading.value = true
    let data = {
        groupUid: shop_detail.value.groupUid,
        shopUid: shop_detail.value.uid,
        uids: id
    };
    const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
    const accessToken = key.accessToken;
    const response = await axios({
        method: 'POST',
        data: data,
        url: st.url_api + `/docgen-svc/backCover/pdf`,
        headers: { Authorization: `Bearer ${accessToken}` },
        responseType: 'arraybuffer',
    });
    loading.value = false
    if (response.headers.get("content-type") === 'application/pdf') {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank').focus();
    } else {
        swal("โหลด PDF ไม่สำเร็จ", "", "error");
    }
}


async function getreplaceTicketNew(id) {
  loading.value = true
  let data = {
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    uids: id
  };
  const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = key.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/docgen-svc/ticket/replace/pdf`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  if (response.headers.get("content-type") === 'application/pdf') {
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank').focus();
  } else {
    swal("โหลด PDF ไม่สำเร็จ", "", "error");
  }
}

async function getDepositInfo(tkRef) {
    let data = "";
    data = {
        index: 0,
        size: 1,
        groupUid: shop_detail.value.groupUid,
        shopUid: shop_detail.value.uid,
        cusUid: '',
        refNumber: '',
        tkRefNumber: tkRef.trim(),
        channel: '',
        txDate: 0,
    };
    const payload = data;
    // console.log("ld p : " + JSON.stringify(payload));
    const response = await storedepo.listDepositFetch(payload);
    // console.log("ld r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                let listd = response.data.data.list
                dep_ref.value = listd[0].refNumber
            }
        }
    }
}

async function getworkCaseInfoPrv(prevRefNumber) {
  let workcase_prv = null
  let data = "";
  data = {
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    refNumber: prevRefNumber,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  //  console.log("workCaseInfoByRef : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcase_prv = response.data.data
        bf_changename.value = workcase_prv.tkCustomerInfo.name 
      }
    }
  }
}

</script>
<style lang="scss" scoped>
.loading-state {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>